function priceChart() {
    if ($('#priceChart').length) {
        try {
            var ctx = document.getElementById('priceChart').getContext('2d');
            var chartData = document.getElementById('priceChart').dataset.chart;
            chartData = JSON.parse(chartData);
            new Chart(ctx, {
                type: 'line',
                data: {
                    labels: chartData.y,
                    datasets: [{
                        data: chartData.x,
                        steppedLine: 'middle',
                        borderColor: '#3D7DCA',
                        fill: false,
                        label: false,
                        pointRadius: 4,
                        pointHoverRadius: 4,
                        pointBackgroundColor: '#3D7DCA',
                    }]
                },
                options: {
                    responsive: true,
                    title: {
                        display: false,
                    },
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        enabled: false,
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                fontColor: getChartColor(.8),
                            },
                            gridLines: {
                                color: getChartColor(.1)
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                fontColor: getChartColor(.8),
                                callback: function (value, index, values) {
                                    return number_format(value, 0, ',', ' ') + ' Kč';
                                }
                            },
                            gridLines: {
                                color: getChartColor(.1)
                            }
                        }],
                    },
                }
            });
        } catch (e) {
            console.log(e);
        }
    }
}

function getChartColor(alpha){
    if(document.body.classList.contains('dark-theme')){
        return `rgba(255,255,255,${alpha})`;
    }else{
        return `rgba(0,0,0,${alpha})`;
    }
}

$(function (){
    priceChart();
})